const isLocalDevBrowser =
  typeof window !== 'undefined' &&
  window.location &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
  window.location.port === '3000';

const DEV_LOCAL_API_BASE = isLocalDevBrowser ? 'http://localhost:5000' : '';

export const API_BASE = (process.env.REACT_APP_API_BASE || DEV_LOCAL_API_BASE || '').replace(/\/+$/, '');
